'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ProjectMemberSearchView = require('common/ui/view/project/member-search');
const ElementAction = require('system/domain/action/element');
const OwnerListView = require('system/ui/view/owner/list');
const OwnerBulkEditModalViewTemplate = require('system/ui/template/modal/owner-bulk-edit.hbs');

module.exports = Mn.View.extend({
    template: OwnerBulkEditModalViewTemplate,
    regions: {
        currentOwners: '.owners-current',
        addOwners: '.owners-add',
        ownerSearch: '.owner-search'
    },
    ui: {
        doneButton: '.done',
        cancelButton: '.cancel'
    },
    events: {
        'click @ui.doneButton': 'done',
        'click @ui.cancelButton': 'cancel'
    },

    initialize: function(params) {
        this._nodes = params.nodes;
        this._context = params.context;
        const group = this.getOption('group');

        const ownerMap = {};
        _.each(this._nodes, function(n) {
            _.each(n.get('owners'), function(ownerId) {
                ownerMap[ownerId] = true;
            });
        });
        this._currentOwners = new Backbone.Collection(
            group.getMembers().getMembersByUserId(_.keys(ownerMap))
        );
        this._addedOwners = new Backbone.Collection();
        this._removedOwners = new Backbone.Collection();
    },

    onRender: function() {
        const group = this.getOption('group');
        const project = this.getOption('project');

        const currentOwnersView = new OwnerListView({
            collection: this._currentOwners,
            context: this._context,
            edit: true
        });
        currentOwnersView.on('remove:owner', _.bind(function(owner) {
            this._currentOwners.remove(owner, {silent: true});
            this._removedOwners.add(owner);
        }, this));
        this.showChildView('currentOwners', currentOwnersView);
        this.showChildView('addOwners', new OwnerListView({
            collection: this._addedOwners,
            context: this._context,
            edit: true
        }));
        this.showChildView('ownerSearch', new ProjectMemberSearchView({
            project: project
        }));
        this.getChildView('ownerSearch').on('select', member => {
            member = group.getMembers().getMemberByUser(member.getUser());
            this._addedOwners.add(member);
        });

        return this;
    },

    show: function() {
        this.$('.modal').modal('show');
    },

    done: function() {
        this._removedOwners.each(function(owner) {
            ElementAction.removeOwnerFromNode({
                context: this._context,
                user: {id: owner.getUser().id.toString()},
                node: _.map(this._nodes, function(n){
                    return n.toJSON();
                })
            });
        }, this);
        this._addedOwners.each(function(owner) {
            ElementAction.addOwnerToNode({
                context: this._context,
                user: {id: owner.getUser().id.toString()},
                node: _.map(this._nodes, function(n){
                    return n.toJSON();
                })
            });
        }, this);
        this.$('.modal').modal('hide');
        this.remove();
    },

    cancel: function() {
        this.$('.modal').modal('hide');
        this.remove();
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/owner-bulk-edit.js